import { Component, Input, OnInit } from "@angular/core";
import { Question } from "../../Models/question.interface";
import { Translation } from "../../Models/translation.interface";
import { SelectedVerse } from "../../Models/selectedVerse.interface";

@Component({
  selector: "question-verses",
  templateUrl: "./question-verses.component.html",
  styleUrls: [
    "./question-verses.component.css",
    "../../templates/question-template/question-template.component.scss",
  ],
})
export class QuestionVersesComponent implements OnInit {
  @Input() question: Question;
  @Input() config;
  constructor() {}

  showVerse = false;
  selectedVerse: SelectedVerse;

  ngOnInit(): void {
    console.log(this.question.verses);
  }

  setVerseShown(bool: boolean) {
    this.showVerse = bool;
  }

  selectVerse(verse) {
    this.selectedVerse = verse;
    this.setVerseShown(true);
  }

  closeModal(event) {
    if (event.target.id === "verseModal") {
      this.showVerse = false;
      this.selectedVerse = null;
    }
  }
  stopPropagation(event) {
    event.stopPropagation();
  }
}
